// REACT
import React, { Component } from 'react';

// CUSTOM COMPONENTS
import { FluidSection } from '../../components/FluidSection/index'
import { Content } from '../../components/Content/index';
import { Hero } from '../../components/Hero/index';
import { List } from '../../components/List/index';

// UTILS
import { constants } from '../../constants/index';

class About extends Component {


  render() {
    return (
      <div style={{...constants.layout.container, ...constants.text.baseFontStyles}}>
        <Hero 
          backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2Fapp%2Bweights-small.jpg?alt=media&token=a9b36965-cd29-43d5-9da7-eb720f750708'} 
          mainTitleText="Health Shouldn’t Wait" 
          subTitleText="We connect people with experts around the world"
          height={300} 
        />
        <FluidSection style={{ maxWidth: 800, marginBottom: -60, }} >
            <Content
              // style={{ marginRight: 40 }} 
               mainTitleTextAlt={"Who we are"} 
               style={{ marginRight: 35, }} 

              /> 
        </FluidSection>
          <FluidSection style={{ maxWidth: 800, marginBottom: -60, }} >
              <Content
                // subTitleText={"Who we are"}
                style={{ marginBottom: 50, marginRight: 35,  }} 
                //  bodyText={''}
                //  ('<ul><li>Family Medicine</li><li>Physiotherapy</li><li>Personal training</li><li>Nutrition</li><li>Naturopath</li><li>Mental wellness</li><li>and many more…</li></ul>')
                >
                <p>Cyno provides instant connection, relationship and guidance between clients and qualified health professionals at anytime, anywhere. Cyno is a virtual marketplace where clients can search for an expert who specializes in solving their health needs at a price that meets their financial expectations.</p>
                  {/* <ul>
                    <li>Family Medicine</li>
                    <li>Physiotherapy</li>
                    <li>Personal training</li>
                    <li>Nutrition</li>
                    <li>Naturopath</li>
                    <li>Mental wellness</li>
                    <li>and many more…</li>
                  </ul> */}
              </Content> 
            </FluidSection>
            <FluidSection 
              style={{ maxWidth: 800, marginBottom: -30, }} 
              >
              <Content
                style={{ marginBottom: 0, marginRight: 0, maxWidth: 500, }} 
                subTitleText={"Our mission"}
                >
                <p>As with most great business ideas, the concept of Cyno began with a problem! In this case, there were three of them:</p>
                <p style={{marginTop:0}}>The corporation is empowered to put a dollar credit on each employee’s Cyno account and the employee can find the specific provider and services that will meet their health needs anytime anywhere. The corporation is only invoiced for credits that are redeemed by the employee.</p>

              </Content> 
              <Content
                backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2Fimg%2FgirlStreatchingOnBeach.jpg?alt=media&token=aa7590eb-b215-4f91-90e3-1942f5c0bb2e'}
                style={{ maxWidth: 400, minWidth: 300, height: 400 }}
              />
              <Content
                style={{ marginTop: 60, marginRight: 0, maxWidth: 500, }} 
                subTitleText={"Partners"}
                >

              </Content> 
          </FluidSection>
          <FluidSection 
            style={{ maxWidth: 800 }} 
            sectionMinWidth= { 200 }
            >
              <Content
                img={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FpartnerLogos%2FgenesesLogo.jpg?alt=media&token=ae5de885-8b40-4622-9ab7-0f1c097d035a'}
                imgWidth= {200}
                style={{ marginTop: 50, marginRight: 0,  }} 
              />
                <Content
                  img={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FpartnerLogos%2FpropelIctLogo.jpg?alt=media&token=91d9f56e-678b-4695-bd7e-7addcd472d9a'}
                  imgWidth= {175}
                  />
              <Content
                img={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FpartnerLogos%2FproactiveLogo.jpg?alt=media&token=f1ed207f-4dbc-49ca-95e1-c4661bc272c3'}
                imgWidth= {200}
                style={{ marginTop: 60, marginRight: 0, }} 
              />
          </FluidSection>
          <FluidSection style={{ maxWidth: 800, marginBottom: -60, }} >
            <Content
              // style={{ marginRight: 40 }} 
               mainTitleTextAlt={"Our Experts"} 
               style={{ marginRight: 35, }} 

              /> 
          </FluidSection>
          <FluidSection style={{ maxWidth: 800, marginBottom: -60, }} >
              <Content
                // subTitleText={"Who we are"}
                style={{ marginBottom: 50, marginRight: 35,  }} 
                //  bodyText={''}
                //  ('<ul><li>Family Medicine</li><li>Physiotherapy</li><li>Personal training</li><li>Nutrition</li><li>Naturopath</li><li>Mental wellness</li><li>and many more…</li></ul>')
                >
                <p>We take great pride in the quality of the health experts that are listed on the Cyno platform. To protect this quality, Cyno validates all health experts to ensure that they have the proper education and insurance to provide their listed services. To further ensure service quality, Cyno offers a secure peer review system so that clients can see the ratings and reviews of any expert they wish to work with.</p>
                  {/* <ul>
                    <li>Family Medicine</li>
                    <li>Physiotherapy</li>
                    <li>Personal training</li>
                    <li>Nutrition</li>
                    <li>Naturopath</li>
                    <li>Mental wellness</li>
                    <li>and many more…</li>
                  </ul> */}
              </Content> 
            </FluidSection>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/js/containers/About/About.jsx